// extracted by mini-css-extract-plugin
export default {"pipeline_wrapper":"Pipeline_pipeline_wrapper__6Kg7F","heading_area":"Pipeline_heading_area__bEVaq","heading":"Pipeline_heading__nD79x","sub_heading":"Pipeline_sub_heading__3UBi3"};